import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { loadScript } from './helpers';
import ThirdPartyScriptLoader from './ThirdPartyScriptLoader';


function ThirdPartyScriptLoaderVM({
  children, scriptId, src, callback, enabled, errorCallback,
}) {
  const [loaded, setLoaded] = useState(enabled);

  useEffect(() => {
    // Callback function to set loaded state as true and execute any callback function
    function onLoad() {
      setLoaded(true);
      if (callback) callback();
    }

    function onError() {
      if (errorCallback) errorCallback();
    }

    if (scriptId && src && enabled) {
      loadScript({
        scriptId,
        src,
        callback: onLoad,
        errorCallback: onError,
      });
    }
  });

  if (enabled) {
    return (loaded && children)
      ? <ThirdPartyScriptLoader>{children}</ThirdPartyScriptLoader>
      : null;
  }

  return <ThirdPartyScriptLoader>{children}</ThirdPartyScriptLoader>;
}
ThirdPartyScriptLoaderVM.propTypes = {
  callback: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  enabled: PropTypes.bool,
  errorCallback: PropTypes.func,
  scriptId: PropTypes.string,
  src: PropTypes.string,
};

ThirdPartyScriptLoaderVM.defaultProps = {
  callback: null,
  children: null,
  enabled: false,
  errorCallback: null,
  scriptId: '',
  src: '',
};

export default ThirdPartyScriptLoaderVM;
